import React from 'react'
import Fade from 'react-reveal/Fade';
import bannerleft from '../Assets/bannerleft.png'
import straws from '../Assets/straws.png';

const Productd = () => {
  return (
    <div className="about-section-container">
      <Fade left>
      <div className="about-background-image-container">
        <img src={bannerleft} alt="" />
      </div>
      <div className="about-section-image-container">
        <img className='image' src={straws} alt="" />
      </div>
      </Fade>
      <div className="about-section-text-container">
      <Fade right>
        <h1 className="product-primary-heading">
        Reusable Bamboo Straws
        </h1>
        <p className="product-primary-text">
        €1.99
        </p>
      </Fade>
        <Fade bottom>
        <div className="about-buttons-container">
          <button className="secondary-button">Buy Now</button>
        </div>
      </Fade>
      </div>
    </div>
  )
}

export default Productd